import api from 'api';

export const SET_GLOBAL_PRICE_LOADING_STATE = 'SET_GLOBAL_PRICE_LOADING_STATE';
export const SET_INITIAL_GLOBAL_PRICE_MODAL_STATE = 'SET_INITIAL_GLOBAL_PRICE_MODAL_STATE';
export const SET_GLOBAL_PRICE_MODAL_STATE = 'SET_GLOBAL_PRICE_MODAL_STATE';
export const UPDATE_GLOBAL_PRICE_ASYNC_ERROR = 'UPDATE_GLOBAL_PRICE_ASYNC_ERROR';
export const RESET_GLOBAL_PRICING_STATE = 'RESET_GLOBAL_PRICING_STATE';
export const SET_PRICE_OUTDATED_WARNING_STATE = 'SET_PRICE_OUTDATED_WARNING_STATE';
export const SET_AFTER_PRICE_OUTDATED_WARNING_STATE = 'SET_AFTER_PRICE_OUTDATED_WARNING_STATE';

const setLoadingStatus = (isLoading) => {
  return {
    type: SET_GLOBAL_PRICE_LOADING_STATE,
    payload: isLoading,
  };
};

export const setGlobalPriceModalState = (isOpen) => {
  return {
    type: SET_INITIAL_GLOBAL_PRICE_MODAL_STATE,
    payload: isOpen,
  };
};

export const setGlobalPriceUpdateModalState = (isModalOpen) => {
  return {
    type: SET_GLOBAL_PRICE_MODAL_STATE,
    payload: isModalOpen,
  };
};

const updateGlobalPriceAsyncError = (error) => {
  return {
    type: UPDATE_GLOBAL_PRICE_ASYNC_ERROR,
    payload: error,
  };
};

/**
 * Initiate global price update
 * @returns
 */
export const updateGlobalPrice = () => {
  return (dispatch) => {
    dispatch(setLoadingStatus(true));
    return api.request('global-price-updates', 'post')
      .then(data => console.log('Global price update: ', data))
      .catch(err => {
        console.log('Error :', err.message);
        dispatch(updateGlobalPriceAsyncError(err && err.message));
        throw err;
      })
      .finally(() => dispatch(setLoadingStatus(false)));
  };
};

/**
 * Action for reset to the initial state
 */
export const resetGlobalPricingState = () => {
  return {
    type: RESET_GLOBAL_PRICING_STATE,
  };
};

export const setPriceOutdatedWarningState = (isPriceOutdatedWarning) => {
  return {
    type: SET_PRICE_OUTDATED_WARNING_STATE,
    payload: isPriceOutdatedWarning,
  };
};

export const setAfterPriceOutdatedWarningState = (isAfterPriceOutdatedWarning) => {
  return {
    type: SET_AFTER_PRICE_OUTDATED_WARNING_STATE,
    payload: isAfterPriceOutdatedWarning,
  };
};
